"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "red",
            d: "m10.84 13.686 2.965-1.687-2.965-1.685z"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "red",
            d: "M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5m5.435 10.999c-.131.49-.513.874-1.003 1.007-.875.237-4.396.24-4.432.24s-3.558-.003-4.432-.239a1.43 1.43 0 0 1-1.003-1.009A15 15 0 0 1 6.328 12c-.005-.921.074-1.841.237-2.748.13-.491.513-.876 1.003-1.009.874-.236 4.396-.239 4.431-.239s3.557.003 4.432.239c.49.134.873.518 1.003 1.01.163.907.242 1.827.237 2.748.005.921-.074 1.841-.237 2.748z"
        })
    ]
}), 'YoutubeRing'); //# sourceMappingURL=index.js.map
